<div class="simulator-card" [ngClass]="{'overflow-hidden': overflowHidden}">
  <!-- Header Section -->
  <div class="simulator-card-header" *ngIf="showHeader">
    <h1 *ngIf="header">{{ header }}</h1>
    <span class="brandline"></span>
  </div>

  <!-- Body Section -->
  <ng-content select="[slot=body]"></ng-content>

  <!-- Footer Section -->
  <div class="simulator-card-footer" *ngIf="showFooter">
    <ng-content select="[slot=footer]"></ng-content>
  </div>
</div>